import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductExperience } from '../components/ProductExperience';
import { CompetitiveEdge } from '../components/CompetitiveEdge';
import { CaseStudy } from '../components/CaseStudy';
import { LeadershipSection } from '../components/LeadershipSection';
import { FinalCTA } from '../components/FinalCTA';
export function FemEntityLanding() {
  return <main className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-purple-200 selection:text-charcoal" data-id="element-349">
      {/* Navigation placeholder - minimal for landing page */}
      <nav className="absolute top-0 left-0 right-0 z-50 px-6 py-6 flex justify-between items-center max-w-7xl mx-auto" data-id="element-350">
        <img src="https://cdn.magicpatterns.com/uploads/xpYure8muF9bisffxXgVg2/fementity.png" alt="Fem Entity" className="h-12 md:h-16 drop-shadow-lg" data-id="element-351" />
        <div className="hidden md:flex space-x-8 text-sm font-medium text-charcoal/80" data-id="element-352">
          <a href="#platform" className="hover:text-purple-700 transition-colors" data-id="element-353">
            Platform
          </a>
          <a href="#practitioners" className="hover:text-purple-700 transition-colors" data-id="element-354">
            Practitioners
          </a>
          <a href="/investors" className="hover:text-purple-700 transition-colors" data-id="element-355">
            Investors
          </a>
        </div>
      </nav>

      <Hero data-id="element-356" />
      <ProblemSection data-id="element-357" />
      <CaseStudy data-id="element-358" />
      <SolutionSection data-id="element-359" />
      <ProductExperience data-id="element-360" />
      <CompetitiveEdge data-id="element-361" />
      <LeadershipSection data-id="element-362" />
      <FinalCTA data-id="element-363" />

      {/* Minimal Footer */}
      <footer className="bg-charcoal text-ivory/50 py-8 text-center text-sm border-t border-white/10" data-id="element-364">
        <p data-id="element-365">© {new Date().getFullYear()} Fem Entity. All rights reserved.</p>
      </footer>
    </main>;
}